<div class="bulk-edit-menu whitespace-nowrap">
  <button mat-flat-button class="button-primary mr-2" type="button" [matMenuTriggerFor]="bulkMenu">
    <mat-icon class="material-icons-outlined">checklist</mat-icon>
    <span class="px-2 font-bold" i18n>Bulk edit</span>
  </button>

  <mat-menu #bulkMenu="matMenu">
    <ng-template matMenuContent>
      <div class="min-w-[12rem]">
        <!-- Loop through the bulk edit menu items -->
        <button *ngFor="let action of actions" mat-menu-item (click)="actionClicked.emit(action.name)">
          <mat-icon class="material-icons-outlined">{{ action.icon }}</mat-icon>
          <span>{{ action.label }}</span>
        </button>
      </div>
    </ng-template>
  </mat-menu>

  <div class="checkbox-container">
    <mat-checkbox
      class="example-margin"
      [labelPosition]="'after'"
      [indeterminate]="selectedItemsCount > 0 && selectedItemsCount < totalItemsCount ? true : false"
      [checked]="selectedItemsCount === totalItemsCount && selectedItemsCount > 0 ? true : false"
      (change)="selectAllClicked.emit(true)"
      #selectAll
    >
      <span>
        <ng-template [ngIf]="selectedItemsCount > 0"><ng-container i18n>Unselect all</ng-container>&nbsp;({{ selectedItemsCount }})</ng-template>
        <ng-template [ngIf]="!selectedItemsCount" i18n>Select all</ng-template>
      </span>
    </mat-checkbox>
  </div>
</div>
